<template>
  <div class="layout-content-list driving-control-page">
    <el-breadcrumb separator="/" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>物流圈</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>行车监控概况</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">创建日期</span>
        <el-date-picker
          v-model="filter.startTime"
          type="date"
          style="width: 140px"
          value-format="timestamp"
          :picker-options="pickerOptions"
          :clearable="false"
          placeholder="选择开始日期"
        ></el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="filter.endTime"
          type="date"
          style="width: 140px"
          value-format="timestamp"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="selectTimeChange"
          placeholder="选择结束日期"
        >
        </el-date-picker>
      </div>

      <div class="toolbar-item" id="auto-1">
        <el-button type="primary" size="small" @click="search">筛选</el-button>
      </div>
    </div>
    <div class="statistics-box pt-20 pb-20">
      <div class="statistics-list-box">
        <p class="statistics-title">异常运单统计</p>
        <div class="statistics-head">
          <el-progress
            type="circle"
            :stroke-width="strokeWidth"
            :width="circleWidth"
            :percentage="getAbnormalOrderPercent"
            color="#F35856"
            :show-text="true"
            :format="formatOrderPercent"
          >
          </el-progress>
        </div>
        <div class="statistics-center">
          <div class="statistics-item">
            <div class="statistics-item-num">{{ allData.orderTotal }}</div>
            <div id="auto-3">运单总数</div>
          </div>
          <div class="statistics-item">
            <span class="abnormal-box">
              <span class="statistics-item-num color-red" id="auto-4">{{ allData.abnormalOrderTotal }}</span>
              <span class="color-green" @click="handleToOrder(0)" id="auto-5">轨迹异常运单&gt;</span>
            </span>
          </div>
        </div>
        <div class="statistics-bottom">
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-6">{{ allData.noLocationOrder }}</div>
            <div class="color-green" @click="handleToOrder(1)" id="auto-7">无定位运单&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-8">{{ allData.midwayStopOrder }}</div>
            <div class="color-green" @click="handleToOrder(2)" id="auto-9">中途停车运单&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-10">{{ allData.timeOutOrder }}</div>
            <div class="color-green" @click="handleToOrder(3)" id="auto-11">运输超时&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-12">{{ allData.appOffLineOrder }}</div>
            <div class="color-green" @click="handleToOrder(4)" id="auto-13">APP离线&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-30">{{ allData.blacklistStopOrder }}</div>
            <div class="color-green" @click="handleToOrder(5)" id="auto-31">黑名单地点停车&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-32">{{ allData.nightStopOrder }}</div>
            <div class="color-green" @click="handleToOrder(6)" id="auto-33">夜间停车&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-34">{{ allData.noLocationWholeOrder }}</div>
            <div class="color-green" @click="handleToOrder(7)" id="auto-35">中交全程无定位&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-41">{{ allData.speedingOrder }}</div>
            <div class="color-green" @click="handleToOrder(8)" id="auto-35">超速&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-41">{{ allData.overloadOrder }}</div>
            <div class="color-green" @click="handleToOrder(9)" id="auto-35">超载&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-41">{{ allData.fatigueDrivingOrder || 0 }}</div>
            <div class="color-green" @click="handleToOrder(10)" id="auto-35">疲劳驾驶&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-41">{{ allData.riskVehicleOrder || 0 }}</div>
            <div class="color-green" @click="handleToOrder(11)" id="auto-35">风险车辆&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-41">{{ allData.riskDriverOrder || 0 }}</div>
            <div class="color-green" @click="handleToOrder(12)" id="auto-35">风险司机&gt;</div>
          </div>
        </div>
      </div>
      <div class="statistics-list-box">
        <p class="statistics-title abnormal">异常司机统计</p>
        <div class="statistics-head">
          <el-progress
            type="circle"
            :stroke-width="strokeWidth"
            :percentage="getAbnormalDriverPercent"
            color="#ff9900"
            :width="circleWidth"
            :show-text="true"
            :format="formatDriverPercent"
          >
          </el-progress>
        </div>
        <div class="statistics-center">
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-15">{{ allData.orderDriver }}</div>
            <div>接单司机</div>
          </div>
          <div class="statistics-item">
            <span class="abnormal-box">
              <span class="statistics-item-num color-yellow" id="auto-16">{{ allData.abnormalOrderDriver }}</span>
              <span class="color-green" @click="handleToDriver(0)" id="auto-17">异常司机&gt;</span>
            </span>
          </div>
        </div>
        <div class="statistics-bottom">
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-18">{{ allData.noLocationDriver }}</div>
            <div class="color-green" @click="handleToDriver(1)" id="auto-19">无定位司机&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-20">{{ allData.midwayStopDriver }}</div>
            <div class="color-green" @click="handleToDriver(2)" id="auto-21">中途停车司机&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-22">{{ allData.timeOutDriver }}</div>
            <div class="color-green" @click="handleToDriver(3)" id="auto-23">运输超时司机&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-24">{{ allData.appOffLineDriver }}</div>
            <div class="color-green" @click="handleToDriver(4)" id="auto-25">APP离线司机&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-36">{{ allData.blacklistStopDriver }}</div>
            <div class="color-green" @click="handleToDriver(5)" id="auto-37">黑名单地点停车&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-38">{{ allData.nightStopDriver }}</div>
            <div class="color-green" @click="handleToDriver(6)" id="auto-39">夜间停车&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-40">{{ allData.noLocationWholeDriver }}</div>
            <div class="color-green" @click="handleToDriver(7)" id="auto-41">中交全程无定位&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-42">{{ allData.speedingDriver }}</div>
            <div class="color-green" @click="handleToDriver(8)" id="auto-41">超速&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-42">{{ allData.overloadDriver }}</div>
            <div class="color-green" @click="handleToDriver(9)" id="auto-41">超载&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-42">{{ allData.fatigueDrivingDriver || 0 }}</div>
            <div class="color-green" @click="handleToDriver(10)" id="auto-41">疲劳驾驶&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-42">{{ allData.riskVehicleCount || 0 }}</div>
            <div class="color-green" @click="handleToDriver(11)" id="auto-41">风险车辆&gt;</div>
          </div>
          <div class="statistics-item">
            <div class="statistics-item-num" id="auto-42">{{ allData.riskDriverCount || 0 }}</div>
            <div class="color-green" @click="handleToDriver(12)" id="auto-41">风险司机&gt;</div>
          </div>
        </div>
      </div>
    </div>
    <div class="statistics-box mb-20">
      <div class="statistics-list-box">
        <p class="statistics-title captain">异常车队长统计</p>
        <div class="statistics-captain">
          <div class="num" id="auto-26">{{ allData.abnormalCaptain }}</div>
          <div class="color-green" @click="handleToCaptain" id="auto-27">异常车队长&gt;</div>
        </div>
      </div>
      <div class="statistics-list-box">
        <p class="statistics-title agent">异常经纪人统计</p>
        <div class="statistics-captain">
          <div class="num" id="auto-28">{{ allData.abnormalAgent }}</div>
          <div class="color-green" @click="handleToAgent" id="auto-29">异常经纪人&gt;</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:41
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axiosNew from '@/api/axiosNew';
import api from '@/api/logistics.api';
import { WUYI, vali } from '@/api/common';
import eventIdMap from '@/views/logistics/eventIdMap';
export default {
  data: function () {
    return {
      typeMap: [
        '',
        'location',
        'park',
        'timeout',
        'offLine',
        'blacklistStop',
        'nightStop',
        'noLocationWhole',
        'overspeed',
        'overload',
        'drowsy',
        'riskcar',
        'riskdriver'
      ],
      companyCode: WUYI.currentData.company.companycode,
      filter: {
        startTime: WUYI.time.timestart,
        endTime: WUYI.time.timeend + 8.64e7 - 1000
      },
      cache: {},
      pickerOptions: {
        disabledDate(time) {
          if (time.getTime() > Date.now()) return true;
          return false;
        }
      },
      strokeWidth: 24,
      circleWidth: 210,
      allData: {}
    };
  },
  created() {
    this[eventIdMap.eventAction]({
      ctp: window.location.href,
      eventId: eventIdMap.drivingControlPage.id,
      event: eventIdMap.drivingControlPage.dec,
      logType: eventIdMap.pageEventType
    });

    this.featchData();
  },
  computed: {
    getAbnormalOrderPercent() {
      return (this.allData.abnormalOrderTotal / this.allData.orderTotal) * 100 || 0;
    },
    getAbnormalDriverPercent() {
      return (this.allData.abnormalOrderDriver / this.allData.orderDriver) * 100 || 0;
    }
  },
  methods: {
    //进度条文字内容
    formatOrderPercent() {
      return `${this.allData.normalOrderTotal}` + '\n' + `正常运单`;
    },
    formatDriverPercent() {
      return `${this.allData.normalOrderDriver}` + '\n' + `正常司机`;
    },
    selectTimeChange(val) {
      this.filter.endTime = val + 8.64e7 - 1000;
    },
    search() {
      this.currentPage = 1;
      this.featchData();
    },
    featchData() {
      if (!WUYI.checkDate(this.filter.startTime, this.filter.endTime)) return;
      if (this.filter.endTime - this.filter.startTime > 1000 * 60 * 60 * 24 * 100) {
        this.$message.error('跨月选择最大时间区域为100天');
        return;
      }
      this.cache = { ...this.filter };
      const options = { companyCode: this.companyCode, ...this.filter };
      axiosNew.post(api.orderCountAll, options).then(res => {
        this.allData = res.data;
      });
    },
    // 跳转到轨迹异常列表
    handleToOrder(type) {
      if (type) {
        this.$router.push({
          path: `/abnormalTrack`,
          query: { type: this.typeMap[type], sDate: this.cache.startTime, eDate: this.cache.endTime }
        });
      } else {
        this.$router.push({
          path: '/abnormalTrack',
          query: { sDate: this.cache.startTime, eDate: this.cache.endTime }
        });
      }
    },
    // 跳转转到异常司机列表
    handleToDriver(type) {
      if (type) {
        this.$router.push({
          path: `/abnormalDriver`,
          query: { type: this.typeMap[type], sDate: this.cache.startTime, eDate: this.cache.endTime }
        });
      } else {
        this.$router.push({
          path: `/abnormalDriver`,
          query: {
            sDate: this.cache.startTime,
            eDate: this.cache.endTime
          }
        });
      }
    },
    // 跳转到 异常车队长列表
    handleToCaptain() {
      this.$router.push({
        path: '/abnormalCaptain',
        query: { sDate: this.cache.startTime, eDate: this.cache.endTime }
      });
    },
    // 跳转到 异常经纪人列表
    handleToAgent() {
      this.$router.push({
        path: '/abnormalAgent',
        query: { sDate: this.cache.startTime, eDate: this.cache.endTime }
      });
    }
  }
};
</script>
<style scoped>
.color-red {
  color: #f35856 !important;
}
.color-yellow {
  color: #ff9900 !important;
}
.color-green {
  cursor: pointer;
  color: #1cc466 !important;
}
.statistics-box {
  display: flex;
  justify-content: space-between;
}
.statistics-list-box {
  flex: 1;
  padding: 20px;

  background: #fff;
}
.statistics-list-box:not(:last-child) {
  margin-right: 20px;
}
.statistics-title {
  position: relative;
  padding: 0 0 0 32px;
  color: #58626b;
  font-size: 22px;
}
.statistics-title:before {
  content: '';
  position: absolute;
  left: 0;
  top: 7px;
  width: 18px;
  height: 18px;
  background: #f35856;
}
.statistics-title.abnormal:before {
  background: #ff9900;
}
.statistics-title.captain:before {
  background: #1cc466;
}
.statistics-title.agent:before {
  background: #3399ff;
}
.statistics-head {
  margin: 20px auto;
  text-align: center;
}
.statistics-head .title {
  margin-bottom: 5px;
  font-size: 16px;
  color: #58626b;
}
.statistics-head .num {
  font-size: 40px;
}

.statistics-center {
  flex: 1;
  display: flex;
  position: relative;
  justify-content: space-between;
  margin: 0 60px;
}
.statistics-center:after {
  content: '';
  position: absolute;
  left: 50%;
  width: 1px;
  height: 52px;
  background: #e8ecef;
  top: 50%;
  margin-top: -26px;
}
.statistics-center .statistics-item:last-child {
  /* padding-left: 50%; */
  text-align: right;
  margin-top: 64px;
}
/* .statistics-center .statistics-item:last-child .statistics-item-num {
    padding-right: 20px;
} */
.abnormal-box {
  position: relative;
}
.abnormal-box .statistics-item-num {
  position: absolute;
  top: -65px;
  left: 0;
}
.statistics-center .statistics-item {
  flex: 1;
  justify-content: space-between;
}
.statistics-center .statistics-item-num {
  font-size: 40px;
  color: #58626b;
}

.statistics-bottom {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin: 40px 0 20px 0;
  background: #f8fafb;
  border: 1px solid #e8ecef;
  border-radius: 3px;
}
.statistics-bottom:before {
  content: '';
  position: absolute;
  right: 100px;
  top: -7px;
  width: 12px;
  height: 12px;
  background: #f8fafb;
  border: 1px solid #e8ecef;
  border-bottom: none;
  border-left: none;
  transform: rotate(-46deg);
  z-index: 0;
}
.statistics-bottom .statistics-item-num {
  font-size: 30px;
  color: #778ca2;
}
.statistics-bottom .statistics-item {
  width: 25%;
  padding: 20px 0 20px 6%;
  box-sizing: border-box;
}
.statistics-captain {
  padding: 36px;
}
.statistics-captain .num {
  font-size: 36px;
}
</style>
<style lang="postcss">
.driving-control-page {
  .el-progress__text {
    white-space: pre-line;
  }
}
</style>
